// extracted by mini-css-extract-plugin
export default {"btnStyle":"styles_btnStyle__jlb2Z","imageWrapperStyle":"styles_imageWrapperStyle__m1BIp","imgStyle":"styles_imgStyle__MT8Xu"};